/*
 * @Author: cc
 * @Date: 2020-03-31 16:16:46
 * @LastEditTime: 2021-05-17 15:27:05
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\components\service\loginService\selectGroupModal\selectGroupCtrl.js
 * @Description: 多组织用户选择弹窗
 */
'use strict';
angular.module('selectGroupCtrlModule', []).controller('loginInitGroupCtrl', ['$scope', '$modalInstance', 'groups', '$timeout',
    function($scope, $modalInstance, groups, $timeout) {
        for (var z = 0;z < groups.length;z++){
            groups[z].GROUPPATH = groups[z].GROUPPATH.split('>').slice(0, -1);
            var words = 0;
            groups[z].itemCount = -1;            
            for (var c = groups[z].GROUPPATH.length - 1;c >= 0;c--){                 
                words += groups[z].GROUPPATH[c].length;
                if (words >= 24){                
                    groups[z].itemCount = c - 1;
                    break;
                }
            } 
        }
        $scope.status = {
            selectedGroup: ''
        };
        $scope.data = {
            groupArray: groups
        };

        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        $scope.confirm = function() {
            $modalInstance.close($scope.status.selectedGroup);
        };
        $scope.selectGroup = function(group) {
            $scope.status.selectedGroup = group;
            $timeout(function() {
                $modalInstance.close($scope.status.selectedGroup);
            }, 300);            
        };

    }
]);
